export class PsOriginBase {
    _origin; // PsOrigin

    assignOrigin(origin) {
        this._origin = origin;
    }

    origin() {
        return this._origin;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsOriginBase.js